import type { ResellerAvailableCatalogsResponse } from '../../@types';
export function resellerAvailablesCatalogs({ data }: ResellerAvailableCatalogsResponse) {
  return data;
}
